import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/forms")({
	component: FormsLayout,
});

function FormsLayout() {
	return <Outlet />;
}
